import { mergeMap } from 'rxjs/operators';
import get from 'lodash.get';
import { of } from 'rxjs';
import * as Api from '../../../../store/bulk/update/bulk.update.api';
import { BulkActions } from '../../../../enums/bulk-actions';
import { shippingConfiguration } from './shipping-configuration';
import { AsyncJobHelper } from '../../../../services/async-job-helper';

const makeApiCallWithIds = (job) => {
  const { bulkUpdateTypeData, ids, model } = job;

  const inFlightWeight = get(model, 'shippingConfiguration.packages[0].weight');
  // TODO: currently supports single weight input component so adjust for expected schema, if adding metric support may need to revert for obj instead of raw weight (use newWeight instead)
  const weight = {
    ...inFlightWeight,
    unit: get(inFlightWeight, 'weightUnit', 'Ounces'),
    value: get(inFlightWeight, 'weight', 0),
  };
  return Api.bulkUpdateAddWeight({
    filters: bulkUpdateTypeData.requestFilter(ids),
    weight,
  }).pipe(
    mergeMap((data) => {
      const foldedData = AsyncJobHelper.foldMultiJobResponse(data);
      return of(foldedData);
    }),
  );
};

const makeApiCallWithJobGuid = (job) => {
  const {
    model,
    jobData: { bulkUpdateJobGuid },
  } = job;

  const inFlightWeight = get(model, 'shippingConfiguration.packages[0].weight');
  // TODO: currently supports single weight input component so adjust for expected schema, if adding metric support may need to revert for obj instead of raw weight (use newWeight instead)
  const weight = {
    ...inFlightWeight,
    unit: get(inFlightWeight, 'weightUnit', 'Ounces'),
    value: get(inFlightWeight, 'weight', 0),
  };
  return Api.bulkAddWeightUpdate({ bulkUpdateJobGuid, weight }).pipe(
    mergeMap((data) => {
      return of(data);
    }),
  );
};

export const adjustWeight = {
  id: 'adjust-weight',
  applicableBulkActions: [BulkActions.adjustWeight],

  handler: (job) => {
    const {
      model,
      jobData: { bulkUpdateJobGuid },
    } = job;

    const weightType = get(model, 'weightType', 'set-weight');
    if (weightType === 'add-weight') {
      const makeApiCall$ = bulkUpdateJobGuid ? makeApiCallWithJobGuid : makeApiCallWithIds;
      return makeApiCall$(job);
    }
    return shippingConfiguration.handler(job);
  },
};
